import Image from 'next/image';
import { toAvatarInitials } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { AvatarProps } from './Avatar.types';

const DEFAULT_SIZE = 72;
const HALVED = 2;

export const Avatar = ({
  userProfilePicture,
  userName,
  size = DEFAULT_SIZE,
  className = '',
  textClassName = '',
}: AvatarProps) => {
  const userNameInitials = toAvatarInitials(userName);

  return (
    <div
      data-test="logged-in-user-avatar"
      className={c(
        `flex items-center justify-center overflow-hidden rounded-full bg-accent`,
        className
      )}
      style={{ width: size, height: size }}
    >
      {userProfilePicture ? (
        <Image width={size} height={size} src={userProfilePicture} alt={''} />
      ) : (
        <div
          className={c(textClassName)}
          style={
            textClassName
              ? undefined
              : {
                  fontSize: size / HALVED,
                }
          }
        >
          {userNameInitials}
        </div>
      )}
    </div>
  );
};
